/**
 * Loading component displayed while PDF-heavy pages are being loaded
 */
export const PDFLoadingFallback = () => (
  <div className="flex items-center justify-center min-h-100">
    <div className="flex flex-col items-center gap-4">
      <div className="relative">
        {/* Animated document icon */}
        <div className="w-16 h-20 bg-gray-100 dark:bg-gray-800 rounded-lg border-2 border-gray-200 dark:border-gray-700 relative overflow-hidden">
          {/* Document lines */}
          <div className="absolute top-3 left-2 right-2 space-y-1.5">
            <div className="h-1.5 bg-gray-200 dark:bg-gray-600 rounded animate-pulse" />
            <div className="h-1.5 bg-gray-200 dark:bg-gray-600 rounded animate-pulse w-3/4" />
            <div className="h-1.5 bg-gray-200 dark:bg-gray-600 rounded animate-pulse w-1/2" />
          </div>
          {/* Corner fold */}
          <div
            className="absolute top-0 right-0 w-4 h-4 bg-gray-200 dark:bg-gray-600"
            style={{ clipPath: "polygon(100% 0, 0 100%, 100% 100%)" }}
          />
        </div>
        {/* Loading spinner overlay */}
        <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-white dark:bg-gray-900 rounded-full flex items-center justify-center shadow-sm border border-gray-200 dark:border-gray-700">
          <div className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin" />
        </div>
      </div>
      <div className="text-center">
        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
          Loading document viewer...
        </p>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          This may take a moment on first load
        </p>
      </div>
    </div>
  </div>
);

export default PDFLoadingFallback;
